// TODO: the list of market holidays needs to be loaded from a web service...but for now HARDCODED...
import { fromSortableString } from "@/helpers/dateTimeUtilities";

export const CentralTimeZone: string = 'America/Chicago';
export const EasternTimeZone: string = 'America/New_York';

const allMarketHolidays: Map< string, string > = new Map< string, string >();

// 2016
allMarketHolidays.set( '2016-01-01', `New Years Day` );
allMarketHolidays.set( '2016-01-18', `Martin Luther King, Jr. Day` );
allMarketHolidays.set( '2016-02-15', `Washington's Birthday` );
allMarketHolidays.set( '2016-03-25', `Good Friday` );
allMarketHolidays.set( '2016-05-30', `Memorial Day` );
allMarketHolidays.set( '2016-07-04', `Independence Day` );
allMarketHolidays.set( '2016-09-05', `Labor Day` );
allMarketHolidays.set( '2016-11-24', `Thanksgiving Day` );
allMarketHolidays.set( '2016-12-26', `Christmas Day` );

// 2017
allMarketHolidays.set( '2017-01-02', `New Years Day` );
allMarketHolidays.set( '2017-01-16', `Martin Luther King, Jr. Day` );
allMarketHolidays.set( '2017-02-20', `Washington's Birthday` );
allMarketHolidays.set( '2017-04-14', `Good Friday` );
allMarketHolidays.set( '2017-05-29', `Memorial Day` );
allMarketHolidays.set( '2017-07-04', `Independence Day` );
allMarketHolidays.set( '2017-09-04', `Labor Day` );
allMarketHolidays.set( '2017-11-23', `Thanksgiving Day` );
allMarketHolidays.set( '2017-12-25', `Christmas Day` );

// 2018
allMarketHolidays.set( '2018-01-01', `New Years Day` );
allMarketHolidays.set( '2018-01-15', `Martin Luther King, Jr. Day` );
allMarketHolidays.set( '2018-02-19', `Washington's Birthday` );
allMarketHolidays.set( '2018-03-30', `Good Friday` );
allMarketHolidays.set( '2018-05-28', `Memorial Day` );
allMarketHolidays.set( '2018-07-04', `Independence Day` );
allMarketHolidays.set( '2018-09-03', `Labor Day` );
allMarketHolidays.set( '2018-11-22', `Thanksgiving Day` );
allMarketHolidays.set( '2018-12-05', `President Bush Funeral` );
allMarketHolidays.set( '2018-12-25', `Christmas Day` );

// 2019
allMarketHolidays.set( '2019-01-01', `New Years Day` );
allMarketHolidays.set( '2019-01-21', `Martin Luther King, Jr. Day` );
allMarketHolidays.set( '2019-02-18', `Washington's Birthday` );
allMarketHolidays.set( '2019-04-19', `Good Friday` );
allMarketHolidays.set( '2019-05-27', `Memorial Day` );
allMarketHolidays.set( '2019-07-04', `Independence Day` );
allMarketHolidays.set( '2019-09-02', `Labor Day` );
allMarketHolidays.set( '2019-11-28', `Thanksgiving Day` );
allMarketHolidays.set( '2019-12-25', `Christmas Day` );

// 2020
allMarketHolidays.set( '2020-01-01', `New Years Day` );
allMarketHolidays.set( '2020-01-20', `Martin Luther King, Jr. Day` );
allMarketHolidays.set( '2020-02-17', `Washington's Birthday` );
allMarketHolidays.set( '2020-04-10', `Good Friday` );
allMarketHolidays.set( '2020-05-25', `Memorial Day` );
allMarketHolidays.set( '2020-07-03', `Independence Day` );
allMarketHolidays.set( '2020-09-07', `Labor Day` );
allMarketHolidays.set( '2020-11-26', `Thanksgiving Day` );
allMarketHolidays.set( '2020-12-25', `Christmas Day` );

// 2021
allMarketHolidays.set( '2021-01-01', `New Years Day` );
allMarketHolidays.set( '2021-01-18', `Martin Luther King, Jr. Day` );
allMarketHolidays.set( '2021-02-15', `Washington's Birthday` );
allMarketHolidays.set( '2021-04-02', `Good Friday` );
allMarketHolidays.set( '2021-05-31', `Memorial Day` );
allMarketHolidays.set( '2021-07-05', `Independence Day` );
allMarketHolidays.set( '2021-09-06', `Labor Day` );
allMarketHolidays.set( '2021-11-25', `Thanksgiving Day` );
allMarketHolidays.set( '2021-12-24', `Christmas Day` );

// 2022
allMarketHolidays.set( '2022-01-17', `Martin Luther King, Jr. Day` );
allMarketHolidays.set( '2022-02-21', `Washington's Birthday` );
allMarketHolidays.set( '2022-04-15', `Good Friday` );
allMarketHolidays.set( '2022-05-30', `Memorial Day` );
allMarketHolidays.set( '2022-06-20', `Juneteenth National Independence Day` );
allMarketHolidays.set( '2022-07-04', `Independence Day` );
allMarketHolidays.set( '2022-09-05', `Labor Day` );
allMarketHolidays.set( '2022-11-24', `Thanksgiving Day` );
allMarketHolidays.set( '2022-12-26', `Christmas Day` );

// 2023
allMarketHolidays.set( '2023-01-02', `New Years Day` );
allMarketHolidays.set( '2023-01-16', `Martin Luther King, Jr. Day` );
allMarketHolidays.set( '2023-02-20', `Washington's Birthday` );
allMarketHolidays.set( '2023-04-07', `Good Friday` );
allMarketHolidays.set( '2023-05-29', `Memorial Day` );
allMarketHolidays.set( '2023-06-19', `Juneteenth National Independence Day` );
allMarketHolidays.set( '2023-07-04', `Independence Day` );
allMarketHolidays.set( '2023-09-04', `Labor Day` );
allMarketHolidays.set( '2023-11-23', `Thanksgiving Day` );
allMarketHolidays.set( '2023-12-25', `Christmas Day` );

// 2024
allMarketHolidays.set( '2024-01-01', `New Years Day` );
allMarketHolidays.set( '2024-01-15', `Martin Luther King, Jr. Day` );
allMarketHolidays.set( '2024-02-19', `Washington's Birthday` );
allMarketHolidays.set( '2024-03-29', `Good Friday` );
allMarketHolidays.set( '2024-05-27', `Memorial Day` );
allMarketHolidays.set( '2024-06-19', `Juneteenth National Independence Day` );
allMarketHolidays.set( '2024-07-04', `Independence Day` );
allMarketHolidays.set( '2024-09-02', `Labor Day` );
allMarketHolidays.set( '2024-11-28', `Thanksgiving Day` );
allMarketHolidays.set( '2024-12-25', `Christmas Day` );

// 2025
allMarketHolidays.set( '2025-01-01', `New Years Day` );
allMarketHolidays.set( '2025-01-09', `National Day of Mourning - President Jimmy Carter` );
allMarketHolidays.set( '2025-01-20', `Martin Luther King, Jr. Day` );
allMarketHolidays.set( '2025-02-17', `Washington's Birthday` );
allMarketHolidays.set( '2025-04-18', `Good Friday` );
allMarketHolidays.set( '2025-05-26', `Memorial Day` );
allMarketHolidays.set( '2025-06-19', `Juneteenth National Independence Day` );
allMarketHolidays.set( '2025-07-04', `Independence Day` );
allMarketHolidays.set( '2025-09-01', `Labor Day` );
allMarketHolidays.set( '2025-11-27', `Thanksgiving Day` );
allMarketHolidays.set( '2025-12-25', `Christmas Day` );

// 2026
allMarketHolidays.set( '2026-01-01', `New Years Day` );
allMarketHolidays.set( '2026-01-19', `Martin Luther King, Jr. Day` );
allMarketHolidays.set( '2026-02-16', `Washington's Birthday` );
allMarketHolidays.set( '2026-04-03', `Good Friday` );
allMarketHolidays.set( '2026-05-25', `Memorial Day` );
allMarketHolidays.set( '2026-06-19', `Juneteenth National Independence Day` );
allMarketHolidays.set( '2026-07-03', `Independence Day` );
allMarketHolidays.set( '2026-09-07', `Labor Day` );
allMarketHolidays.set( '2026-11-26', `Thanksgiving Day` );
allMarketHolidays.set( '2026-12-25', `Christmas Day` );

export const marketHolidayDates: Date[] = [ ...allMarketHolidays.keys() ].map( ( dt: string ) =>
    fromSortableString( dt ).setZone( EasternTimeZone ).endOf( 'day' ).toJSDate()
);

// const marketHolidayDateStrings: string[] = [ ...allMarketHolidays.keys() ];
export function isMarketHoliday( dateString: string ): boolean {
    return allMarketHolidays.has( dateString );
}

export function marketHolidayLabel( date: string ): string {
    return allMarketHolidays.get( date ) ?? `INVALID MARKET DATE: ${ date }`;
}
